import React from 'react';
import './index.css';

export default class Text extends React.Component {

  constructor(props) {
    super(props);
    this.obstacle = React.createRef();
    this.state = { 
      text:''
    };
  }


  componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      let len = document.getElementById("text").childElementCount
        for (let i = 0; i < len; i++) {
          document.getElementById('text_'+i).style.color = 'black';
        }
    }   
  }


//style={{left : this.state.xPos}}
//onKeyDown={this.handleKeyDown} -add back for old functionality
  render() {
    return (
      <div id="text" >
        {
          this.props.text.split('').map((char,i) => <span key={'text_'+i} id={'text_'+i}>{char.toLowerCase()}</span>)
        }
      </div>
    );
  }
}
